import type { ILoggedBusiness } from '../interfaces/i-logged-business';

// Paleta e arquivos do KV VMCORE. Os demais tenants mantêm sua identidade.
export const VMCORE_BRAND = {
  primary: '#0056ED',
  blue: '#4398F1',
  navy: '#081A37',
  pale: '#E8F1FD',
  logo: '/svgs/logo%20principal.svg',
  logoLight: '/svgs/logo%20principal%20branco.svg',
  icon: '/svgs/icon%20azul.svg',
  iconLight: '/svgs/icon%20branco.svg',
} as const;

export const LEGACY_BUSINESS_PRIMARY_COLOR = '#3F8EFC';

export function getBusinessPrimaryColor(
  business?: ILoggedBusiness | null
): string | null {
  if (!business || business.slug === 'vmcore') return null;

  const color = business.configuracoes?.corPrimaria;
  return color && /^#([0-9A-F]{3}|[0-9A-F]{6})$/i.test(color)
    ? color
    : LEGACY_BUSINESS_PRIMARY_COLOR;
}

export function getBusinessLogo(
  business?: ILoggedBusiness | null,
  tone: 'light' | 'dark' = 'dark'
): string | null {
  if (business?.slug === 'vmcore') {
    return tone === 'light' ? VMCORE_BRAND.logoLight : VMCORE_BRAND.logo;
  }

  return business?.configuracoes?.logo || null;
}
